
document.addEventListener("DOMContentLoaded", () => {
  const hub = document.getElementById("pg-hub");
  if (!hub) return;

  let base = hub.dataset.base || "/apps/interest?subpath=";
  // Force proxy base to storefront-relative to ensure Shopify signs the request.
  if (/^https?:\/\//i.test(base)) {
    try {
      const u = new URL(base);
      base = u.pathname + (u.search || "");
    } catch (e) {
      base = "/apps/interest?subpath=";
    }
  }
  if (!base.includes("subpath=")) {
    base = "/apps/interest?subpath=";
  }

  const url = new URL(window.location.href);
  const token = url.searchParams.get("t") || url.searchParams.get("token") || "";
  const voteId = url.searchParams.get("vote_id") || "";
  const subpath = url.searchParams.get("subpath") || "";
  const dropId = url.searchParams.get("drop_id") || "";

  const allowedProxySubpaths = new Set([
    "list",
    "my-waitlist",
    "waitlist",
    "alerts",
    "suggest",
    "vote",
    "join",
  ]);
  const initialProxySubpath = allowedProxySubpaths.has(subpath) ? subpath : "";

  const subpaths = {
    list: "list",
    waitlist: "waitlist",
    alerts: "alerts",
    suggest: "suggest",
    vote: "vote",
  };

  const frames = {
    list: document.getElementById("pd-frame-list"),
    waitlist: document.getElementById("pd-frame-waitlist"),
    alerts: document.getElementById("pd-frame-alerts"),
    suggest: document.getElementById("pd-frame-suggest"),
    vote: document.getElementById("pd-frame-vote"),
  };

  function buildSrc(key, overrideSubpath, extraParams) {
    const sub = overrideSubpath || subpaths[key] || subpaths.list;
    let u;
    try {
      u = new URL(base, window.location.origin);
    } catch (e) {
      u = new URL("/apps/interest?subpath=list", window.location.origin);
    }

    u.searchParams.set("subpath", sub);
    if (token) {
      u.searchParams.set("t", token);
    }
    if (extraParams && typeof extraParams === "object") {
      Object.entries(extraParams).forEach(([k, v]) => {
        if (v !== null && v !== undefined && v !== "") {
          u.searchParams.set(k, String(v));
        }
      });
    }

    return `${u.pathname}?${u.searchParams.toString()}`;
  }

  function buildVoteConfirmSrc() {
    if (!token || !voteId) return buildSrc("vote");
    return `/apps/interest?subpath=vote_confirm&vote_id=${encodeURIComponent(voteId)}&t=${encodeURIComponent(token)}`;
  }

  let usedInitialOverride = false;

  function activate(key) {
    document.querySelectorAll(".pd-shortcuts a").forEach((a) => {
      a.classList.toggle("is-active", a.dataset.hash === key);
    });

    document.querySelectorAll("[data-panel]").forEach((p) => {
      p.classList.toggle("is-active", p.dataset.panel === key);
    });

    const frame = frames[key];
    if (frame && !frame.src) {
      if (key === "vote") {
        frame.src = buildVoteConfirmSrc();
        return;
      }

      if (key === "list" && initialProxySubpath === "join" && !usedInitialOverride) {
        usedInitialOverride = true;
        const joinDropId = /^\d+$/.test(String(dropId)) ? dropId : "";
        frame.src = buildSrc(key, "join", joinDropId ? { drop_id: joinDropId } : null);
        return;
      }

      frame.src = buildSrc(key);
    }
  }

  function currentKey() {
    const h = (window.location.hash || "").replace("#", "");
    return subpaths[h] ? h : "list";
  }

  if (token && voteId && subpath === "vote_confirm") {
    window.location.hash = "#vote";
  }

  window.addEventListener("hashchange", () => activate(currentKey()));

  function isTrustedOrigin(origin) {
    if (origin === window.location.origin) return true;
    try {
      const host = new URL(origin).hostname || "";
      return (
        host === "peachgifts.com" ||
        host.endsWith(".peachgifts.com") ||
        host.endsWith(".myshopify.com")
      );
    } catch {
      return false;
    }
  }

  window.addEventListener("message", (e) => {
    if (!isTrustedOrigin(e.origin)) {
      if (e?.data?.type === "peach.join_complete") {
        console.warn("[peachdrops] join_complete blocked by origin", {
          origin: e.origin,
        });
      }
      return;
    }
    if (e?.data?.type === "peach.join_complete" && e?.data?.checkout_url) {
      const panel = document.querySelector('[data-panel="list"]');
      if (!panel) return;
      let checkoutHref = "";
      try {
        const parsed = new URL(String(e.data.checkout_url), window.location.origin);
        if (/^https?:$/.test(parsed.protocol)) {
          checkoutHref = parsed.toString();
        }
      } catch (_) {
        checkoutHref = "";
      }
      if (!checkoutHref) return;

      panel.textContent = "";
      const card = document.createElement("div");
      card.style.cssText = "padding:16px;border:1px solid var(--border);border-radius:16px;background:#fff;";
      const h3 = document.createElement("h3");
      h3.textContent = "You are in";
      h3.style.cssText = "margin:0 0 8px 0;";
      const p = document.createElement("p");
      p.textContent = "Continue to checkout to complete your order.";
      p.style.cssText = "margin:0 0 12px 0;opacity:.8;";
      const a = document.createElement("a");
      a.href = checkoutHref;
      a.className = "button button--primary";
      a.style.cssText = "display:inline-block;padding:12px 16px;border-radius:12px;text-decoration:none;color:#fff;background:#111827;";
      a.textContent = "Continue to checkout";
      card.appendChild(h3);
      card.appendChild(p);
      card.appendChild(a);
      panel.appendChild(card);
      if (window.location.hash !== "#list") {
        window.location.hash = "#list";
      }
      return;
    }
    if (e?.data?.type === "peach.vote_complete") {
      if (window.location.hash !== "#vote") {
        window.location.hash = "#vote";
      }
      const frame = frames.vote;
      if (frame && frame.src) {
        frame.src = frame.src;
      }
    }
  });

  activate(currentKey());
});
